module.exports = __webpack_public_path__ + "resources/img/img_intermax_2.2402d888ca52fe5404aa040d4a1584d5.png";